(function () {
  'use strict';

  var recsLoaded = false;
  var cachedProducts = [];

  function init() {
    var drawerEl = document.querySelector('cart-drawer');
    if (!drawerEl) return;

    interceptCartIcon(drawerEl);

    var origOpen = drawerEl.open;
    if (typeof origOpen === 'function') {
      drawerEl.open = function (triggeredBy) {
        origOpen.call(this, triggeredBy);
        if (!recsLoaded) {
          loadRecommendations();
        } else {
          requestAnimationFrame(function () { injectCachedRecs(); });
        }
      };
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        requestAnimationFrame(function () {
          updateDrawerCount();
          if (recsLoaded) injectCachedRecs();
        });
      });
    }
  }

  function interceptCartIcon(drawerEl) {
    var cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (typeof drawerEl.open === 'function') {
        drawerEl.open(cartLink);
      } else {
        drawerEl.classList.add('animate', 'active');
        document.body.classList.add('overflow-hidden');
      }
      if (!recsLoaded) {
        loadRecommendations();
      } else {
        requestAnimationFrame(function () { injectCachedRecs(); });
      }
    });
  }

  function updateDrawerCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var el = document.querySelector('.cart-drawer__count');
        if (el) el.textContent = '(' + cart.item_count + ')';
      })
      .catch(function () {});
  }

  function loadRecommendations() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) return;
        var productId = cart.items[0].product_id;
        return fetch('/recommendations/products.json?product_id=' + productId + '&limit=4&intent=related');
      })
      .then(function (r) { return r && r.json(); })
      .then(function (data) {
        if (!data || !data.products || !data.products.length) {
          hideRecommendations();
          return;
        }
        cachedProducts = data.products;
        recsLoaded = true;
        injectCachedRecs();
      })
      .catch(function () {
        hideRecommendations();
      });
  }

  function hideRecommendations() {
    var section = document.getElementById('CartDrawer-Recommendations');
    if (section) section.style.display = 'none';
  }

  function injectCachedRecs() {
    var track = document.getElementById('CartDrawer-RecTrack');
    var dots = document.getElementById('CartDrawer-RecDots');
    if (!track || !cachedProducts.length) return;
    if (track.children.length > 0) return;

    var section = document.getElementById('CartDrawer-Recommendations');
    if (section) section.style.display = '';

    track.innerHTML = '';
    if (dots) dots.innerHTML = '';

    cachedProducts.forEach(function (product, i) {
      var variant = product.variants[0];
      var price = formatMoney(variant.price);
      var imgSrc = product.featured_image
        ? getSizedImage(product.featured_image, '160x160')
        : '';
      var metal = product.variants[0].option1 || '';

      var card = document.createElement('div');
      card.className = 'cart-drawer__rec-card';
      card.innerHTML =
        '<div class="cart-drawer__rec-image-wrap">' +
          (imgSrc ? '<img src="' + imgSrc + '" alt="' + escHtml(product.title) + '" class="cart-drawer__rec-image" loading="lazy" width="80" height="80">' : '') +
        '</div>' +
        '<div class="cart-drawer__rec-info">' +
          '<p class="cart-drawer__rec-name">' + escHtml(product.title) + '</p>' +
          (metal ? '<p class="cart-drawer__rec-metal">' + escHtml(metal) + '</p>' : '') +
          '<p class="cart-drawer__rec-price">' + price + '</p>' +
          '<button class="cart-drawer__rec-add" data-variant-id="' + variant.id + '" aria-label="Add ' + escHtml(product.title) + ' to bag">+ ADD</button>' +
        '</div>';
      track.appendChild(card);

      if (dots) {
        var dot = document.createElement('button');
        dot.className = 'cart-drawer__rec-dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to recommendation ' + (i + 1));
        dot.addEventListener('click', scrollRecTo.bind(null, i));
        dots.appendChild(dot);
      }
    });

    track.removeEventListener('click', handleRecAdd);
    track.addEventListener('click', handleRecAdd);

    track.removeEventListener('scroll', syncDots);
    track.addEventListener('scroll', syncDots, { passive: true });
  }

  function handleRecAdd(e) {
    var addBtn = e.target.closest('.cart-drawer__rec-add');
    if (!addBtn) return;
    var variantId = addBtn.dataset.variantId;
    addBtn.textContent = 'Adding...';
    addBtn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        addBtn.textContent = '✓ Added';
        return fetch(window.routes.cart_url + '?section_id=cart-drawer');
      })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var selectors = ['cart-drawer-items', '.cart-drawer__footer'];
        selectors.forEach(function (sel) {
          var source = doc.querySelector(sel);
          var target = document.querySelector(sel);
          if (source && target) target.replaceWith(source);
        });
        updateDrawerCount();
        updateHeaderBubble();

        var drawerEl = document.querySelector('cart-drawer');
        if (drawerEl) drawerEl.classList.remove('is-empty');

        requestAnimationFrame(function () { injectCachedRecs(); });
      })
      .catch(function () {
        addBtn.textContent = '+ ADD';
        addBtn.disabled = false;
      });
  }

  function updateHeaderBubble() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble) {
          fetch('/?section_id=cart-icon-bubble')
            .then(function (r) { return r.text(); })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var source = doc.querySelector('.shopify-section');
              if (source && bubble) bubble.innerHTML = source.innerHTML;
            });
        }
      })
      .catch(function () {});
  }

  function scrollRecTo(index) {
    var track = document.getElementById('CartDrawer-RecTrack');
    if (!track) return;
    var cards = track.querySelectorAll('.cart-drawer__rec-card');
    if (cards[index]) {
      track.scrollTo({ left: cards[index].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
  }

  function syncDots() {
    var track = document.getElementById('CartDrawer-RecTrack');
    var dots = document.getElementById('CartDrawer-RecDots');
    if (!track || !dots) return;
    var cards = track.querySelectorAll('.cart-drawer__rec-card');
    var dotEls = dots.querySelectorAll('.cart-drawer__rec-dot');
    if (!cards.length || !dotEls.length) return;
    var scrollLeft = track.scrollLeft;
    var cardWidth = cards[0].offsetWidth + 14;
    var activeIndex = Math.round(scrollLeft / cardWidth);
    dotEls.forEach(function (d, i) {
      d.classList.toggle('is-active', i === activeIndex);
    });
  }

  function formatMoney(cents) {
    return '£' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function escHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function getSizedImage(src, size) {
    if (!src) return '';
    return src.replace(/(\.\w+)(\?|$)/, '_' + size + '$1$2');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
